import Flickity from 'flickity';
require('flickity-imagesloaded');

window.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelector('.product-bundle__carousel');

  if (slides) {

    const shouldWatchCss = [...slides.querySelectorAll('.product-bundle__carousel-item')].length < 4;

    new Flickity(slides, {
      // imagesLoaded: true,
      cellAlign: 'left',
      pageDots: false,
      wrapAround: false,
      prevNextButtons: true,
      watchCSS: shouldWatchCss,
      // selectedAttraction: 0.028,
      // friction: 0.25,
      cellSelector: '.product-bundle__carousel-item'
    })
  }


});